import React, { useEffect, useRef, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import CollapseHeader from "../../../core/common/collapse-header";
import { SelectWithImage2 } from "../../../core/common/selectWithImage2";
import { Dropdown, Accordion, Button, Modal, Form } from 'react-bootstrap';
import DefaultEditor from "react-simple-wysiwyg";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { duration, options1, status } from "../../../core/common/selectoption/selectoption";
import { TagsInput } from "react-tag-input-component";
import {
  optionssymbol,
  priorityList,
  project,
  salestypelist,
  socialMedia,
  tagInputValues,
} from "../../../core/common/selectoption/selectoption";
import dragula, { Drake } from "dragula";
import "dragula/dist/dragula.css";
// Importações de componentes e hooks
import { useFunnels } from '../../../hooks/useFunnels';
import { useOpportunityHandler, Opportunity } from './OpportunityFormHandler';
import { useKanbanLazyLoading } from '../../../hooks/useKanbanLazyLoading';
import FunnelSelector from './funnelSelector';
import OpportunityForm from './OpportunityForm';
import ModalSucessoContrato from './components/ModalSucessoContrato';
import FilterComponent, { FilterComponentProps } from './components/FilterComponent';
import KanbanColumn from './components/KanbanColumn';
import SearchComponent from './components/SearchComponent';
import { Stage, Funnel } from '../../../types/funnels';
import { OpportunityCreate, OpportunityFormData, OpportunityData, OpportunityStatus, CreateOpportunityData, TempoEntrega } from '../../../types/opportunity';
import { CustomField as ApiCustomField } from '../../../types/camposPersonalizados';
import { Modal as BootstrapModal, Offcanvas } from 'bootstrap';
import { apiService } from "../../../services/api";
import TooltipTitle from './components/TooltipTitle';
import ModalMudancaEtapa, { DetalhesMudancaEtapa } from './components/ModalMudancaEtapa';
import ModalSemAnexo from './components/ModalSemAnexo';
import handleStageFieldsUpdate from './components/handleStageFieldsUpdate';
import { ProtectedComponent } from '../../../components/ProtectedComponent';
import { usePermissions } from '../../../hooks/usePermissions';

// Interface local
interface EtapaLazyData {
  opportunities: Opportunity[];
  loading: boolean;
  hasMore: boolean;
  currentPage: number;
  totalPages: number;
  total: number;
  initialized: boolean;
  error: string | null;
}

// Tipo para contexto de loading
type LoadingContext = 'initial' | 'filtering' | 'searching' | 'changing-funnel' | null;

// Interface para campos customizados
interface CustomField {
  id: number;
  title: string;
  type: string;
  required: boolean;
  value?: any;
}

// Interface para opção de select
interface SelectOption {
  value: string | number;
  label: string;
}

export const DealsKanban = () => {
  const { hasPermission } = usePermissions();

  const {
    funnels,
    loading: funnelsLoading,
    error: funnelsError,
    selectedFunnel,
    setSelectedFunnel
  } = useFunnels();

  // Hook original mantido para compatibilidade com CRUD operations
  const {
    opportunities,
    loading: opportunitiesLoading,
    error: opportunitiesError,
    setOpportunities,
    renderOpportunityCard: originalRenderOpportunityCard,
    handlePrepareDeleteOpportunity,
    addNewOpportunity,
    handleDeleteOpportunity: originalHandleDeleteOpportunity,
    deletingOpportunityId,
    isDeleting,
    handleUpdateOpportunity,
    editingOpportunity,
    setEditingOpportunity,
    currentOpportunityId,
    setCurrentOpportunityId,
    applyStatusFilters,
    // Novos estados
    showModalSucessoContrato,
    setShowModalSucessoContrato,
    contratoGeradoId,
    setContratoGeradoId
  } = useOpportunityHandler("2");

  // Estados para filtros de status (movido para depois do hook original)
  const [statusFilters, setStatusFilters] = useState<string[]>(['Aberta', 'Em Andamento']);

  // Estado para pesquisa
  const [searchTerm, setSearchTerm] = useState<string>('');

  // Estado para contexto de loading
  const [loadingContext, setLoadingContext] = useState<LoadingContext>('initial');

  // Hook do lazy loading integrado
  const {
    etapasData,
    globalLoading,
    loadMoreEtapa,
    initializeAllStages,
    refreshEtapa,
    refreshAll,
    getEtapaData,
    updateOpportunityInEtapa,
    moveOpportunityBetweenEtapas,
    addOpportunityToEtapa,
    removeOpportunityFromEtapa
  } = useKanbanLazyLoading({
    funnelId: selectedFunnel?.id || 2,
    stages: selectedFunnel?.etapas || [],
    filters: {
      id_conta: 2,
      status: statusFilters,
      search: searchTerm
    },
    limitPerStage: 20,
    autoInitialize: true
  });



  const [owner, setOwner] = useState(["Collab"]);
  const [openModal, setOpenModal] = useState(false);
  const [showModalSemAnexo, setShowModalSemAnexo] = useState(false);
  const [oportunidadeSemAnexo, setOportunidadeSemAnexo] = useState<string>('');
  const [showModalMudancaEtapa, setShowModalMudancaEtapa] = useState<boolean>(false);
  const [detalhesMudancaEtapa, setDetalhesMudancaEtapa] = useState<DetalhesMudancaEtapa>({
    oportunidadeId: null,
    tituloOportunidade: '',
    novaEtapaId: 0,
    novaEtapaNome: '',
    etapaAntigaId: null
  });
  const [atualizandoEtapa, setAtualizandoEtapa] = useState<boolean>(false);
  
  // Função customizada para preparar e abrir modal de exclusão
  const handleCustomPrepareDelete = (opportunityId: string) => {
    // Prepara o ID para exclusão
    handlePrepareDeleteOpportunity(opportunityId);
    
    // Abre o modal manualmente sem usar Bootstrap
    setTimeout(() => {
      const deleteModal = document.getElementById('delete_opportunity');
      if (deleteModal) {
        (deleteModal as HTMLElement).style.display = 'block';
        deleteModal.classList.add('show');
        deleteModal.setAttribute('aria-modal', 'true');
        deleteModal.removeAttribute('aria-hidden');
        
        const backdrop = document.createElement('div');
        backdrop.className = 'modal-backdrop fade show';
        document.body.appendChild(backdrop);
        document.body.classList.add('modal-open');
      }
    }, 10);
  };

  // Estado para controlar loading do botão de deletar
  const [isDeletingLocal, setIsDeletingLocal] = useState(false);

  // Função customizada para deletar oportunidade sem conflitos de modal
  const handleDeleteOpportunity = async () => {
    if (!deletingOpportunityId || isDeletingLocal) return;
    
    setIsDeletingLocal(true);
    
    try {
      // Faz a chamada da API diretamente, sem usar a função original
      await apiService.deleteOpportunity(deletingOpportunityId);
      
      // Atualiza a lista de oportunidades (mesmo comportamento do hook original)
      setOpportunities(prev => prev.filter(opp => Number(opp.id) !== deletingOpportunityId));
      
      // Remover da etapa correspondente no lazy loading
      // Encontrar a etapa da oportunidade
      let removedFromEtapa: number | null = null;
      Array.from(etapasData.entries()).forEach(([etapaId, etapaData]) => {
        const hasOpportunity = etapaData.opportunities.some((opp: Opportunity) => opp.id === deletingOpportunityId.toString());
        if (hasOpportunity) {
          removeOpportunityFromEtapa(deletingOpportunityId.toString(), etapaId);
          removedFromEtapa = etapaId;
        }
      });
      
      // Nossa limpeza robusta de modais
      forceCloseAllModals();
      
      // Aguardar um pouco para garantir que a limpeza foi concluída
      await new Promise(resolve => setTimeout(resolve, 150));
      
      // Mostra modal de sucesso manualmente sem conflitos
      const successModal = document.getElementById('success_delete_modal');
      if (successModal) {
        // Remover qualquer backdrop antigo primeiro
        const oldBackdrops = document.querySelectorAll('.modal-backdrop');
        oldBackdrops.forEach(backdrop => backdrop.remove());
        
        // Configurar o modal
        (successModal as HTMLElement).style.display = 'block';
        successModal.classList.add('show');
        successModal.setAttribute('aria-modal', 'true');
        successModal.removeAttribute('aria-hidden');
        
        // Criar backdrop específico para o modal de sucesso
        const backdrop = document.createElement('div');
        backdrop.className = 'modal-backdrop fade show';
        backdrop.id = 'success-modal-backdrop';
        backdrop.style.zIndex = '1040'; // Z-index padrão do Bootstrap para backdrops
        document.body.appendChild(backdrop);
        document.body.classList.add('modal-open');
        
        // Garantir que o modal tenha z-index superior ao backdrop
        (successModal as HTMLElement).style.zIndex = '1050';
      }
      
    } catch (error) {
      console.error('Erro ao excluir oportunidade:', error);
      forceCloseAllModals();
      alert('Erro ao excluir a oportunidade. Por favor, tente novamente.');
    } finally {
      setIsDeletingLocal(false);
    }
  };

  // Função customizada para renderizar cartão de oportunidade (layout original) sem conflitos de modal
  const renderOpportunityCard = (opp: Opportunity) => {

    const initials = opp.title
      .split(' ')
      .map(name => name[0])
      .slice(0, 2)
      .join('')
      .toUpperCase() || 'OO';

    interface TempoEntregaOption {
      value: string;
      label: string;
    }

    const formatDate = (date: Date) => {
      const months = [
        'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
        'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
      ];

      const day = date.getDate().toString().padStart(2, '0');
      const month = months[date.getMonth()];
      const year = date.getFullYear();
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');

      return `${day} ${month} ${year} ${hours}:${minutes}`;
    };

    const getStatusColor = (statusName: string, eFinal?: boolean) => {
      if (eFinal) {
        if (statusName === 'Ganha') return 'bg-success';
        if (statusName === 'Perdida') return 'bg-danger';
        if (statusName === 'Cancelada') return 'bg-secondary';
        return 'bg-info'; // Outros status finais
      }

      switch (statusName.toLowerCase()) {
        case 'em andamento':
          return 'bg-warning';
        case 'aberta':
          return 'bg-warning';
        default:
          return 'bg-secondary';
      }
    };

    const handlePrepareEditOpportunity = (opp: Opportunity) => {
      setEditingOpportunity(opp);
    };

    return (
      <div key={opp.id} className="card kanban-card border">
        <div className="card-body">
          <div className="d-block">
            <div className={`${opp.bgColor} border border-2 mb-3`} />
            <div className="d-flex align-items-center mb-3 title">
              <h6 className="d-flex justify-content-between fw-medium">
                <Link to={`/crm/oportunidades/detalhes/${opp.id}`}>
                  {opp.title}
                </Link>
              </h6>
            </div>
          </div>
          <div className="mb-1 d-flex flex-column gap-1">
            <p className="text-default d-inline-flex align-items-center">
              <i className="ti ti-user text-dark me-1" />
              {opp.contact}
            </p>
            <p className="text-default d-inline-flex align-items-center">
              <i className="ti ti-code text-dark me-1" />
              UASG: {opp.uasb || 'Não informado'}
            </p>
            <p className="text-default d-inline-flex align-items-center">
              <i className="ti ti-file-invoice text-dark me-1" />
              N° do Contrato: {opp.numero_contrato}
            </p>
            <p className="text-default d-inline-flex align-items-center">
              <i className="ti ti-building text-dark me-1" />
              {opp.source ? `${opp.source}` : 'Não informado'}
            </p>
            <p className="text-default d-inline-flex align-items-center">
              <i className="ti-world text-dark me-1" />
              {opp.url_site_externo && opp.url_site_externo.trim() !== "" ? (
                <a
                  href={/^https?:\/\//i.test(opp.url_site_externo) ? opp.url_site_externo : `https://${opp.url_site_externo}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary text-truncate"
                  style={{ maxWidth: '180px' }}
                  title={opp.url_site_externo}
                >
                  {opp.url_site_externo.replace(/^https?:\/\//i, '')}
                </a>
              ) : (
                <span className="text-muted">Não informado</span>
              )}
            </p>
            <p className="text-default d-inline-flex align-items-center">
              <i className="ti ti-report-money text-dark me-1" />
              {opp.value}
            </p>
            <p className="text-default d-inline-flex align-items-center flex-nowrap">
              <i className="ti-package text-dark me-1" />
              <span style={{ whiteSpace: 'nowrap' }}>
                Tempo de entrega:&nbsp;
                <span className={`badge ${
                  typeof opp.tempo_entrega === 'object' && opp.tempo_entrega !== null
                    ? ((opp.tempo_entrega as unknown) as TempoEntregaOption).value === 'Única'
                      ? 'bg-success'
                      : ((opp.tempo_entrega as unknown) as TempoEntregaOption).value === 'Fracionada'
                        ? 'bg-warning'
                        : 'bg-secondary'
                    : opp.tempo_entrega === 'Única'
                      ? 'bg-success'
                      : opp.tempo_entrega === 'Fracionada'
                        ? 'bg-warning'
                        : 'bg-secondary'
                }`}>
                  {typeof opp.tempo_entrega === 'object' && opp.tempo_entrega !== null
                    ? ((opp.tempo_entrega as unknown) as TempoEntregaOption).label
                    : opp.tempo_entrega || 'Sem informação'}
                </span>
              </span>
            </p>
          </div>
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center">
              <Link
                to="#"
                className="avatar avatar-xs avatar-rounded avatar-gray flex-shrink-0 me-2"
              >
                {opp.owner.avatar ? (
                  <ImageWithBasePath
                    src={opp.owner.avatar}
                    alt={opp.owner.name}
                  />
                ) : (
                  <span className="avatar-title">
                    {opp.owner.name.charAt(0)}
                  </span>
                )}
              </Link>
              <Link
                to="#"
                className="text-default"
              >
                {opp.owner.name}
              </Link>
            </div>
          </div>
          <div className="d-flex align-items-center justify-content-between border-top pt-3 mt-3">
            <span>
              <i className="ti ti-calendar-due" /> {formatDate(opp.bidDate)}
            </span>
            <span className={`badge ${getStatusColor(opp.status, opp.status_e_final)}`}>
              {opp.status}
            </span>
          </div>
          <div className="d-flex gap-1 mt-3">
            <ProtectedComponent module="OPORTUNIDADES" action="EDITAR">
              <button
                className="btn btn-success btn-sm mr-3"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvas_edit"
                onClick={() => handlePrepareEditOpportunity(opp)}
              >
                Editar
              </button>
            </ProtectedComponent>
            <ProtectedComponent module="OPORTUNIDADES" action="EXCLUIR">
              <button
                className="btn btn-danger btn-sm"
                onClick={() => handleCustomPrepareDelete(opp.id)}
              >
                Excluir
              </button>
            </ProtectedComponent>
          </div>
        </div>
      </div>
    );
  };

  function isStageWithId(stage: Stage): stage is Stage & { id: number } {
    return typeof stage.id === 'number';
  }

  function createUpdatedOpportunity(
    original: Opportunity,
    novaEtapaId: number,
    novaEtapaNome: string
  ): Opportunity {
    return {
      ...original,
      stage_id: novaEtapaId,
      stage: novaEtapaNome
    };
  }


  const route = all_routes;

  // Estados para o novo formulário
  const [bidDate, setBidDate] = useState<Date | null>(new Date());
  const [openingDate] = useState<Date>(new Date());
  const [closingDate, setClosingDate] = useState<Date | null>(null);
  const [filterLoading, setFilterLoading] = useState(false);



  // Opções dos selects
  const sourceOptions = [
    { value: 'site', label: 'Site' },
    { value: 'indicacao', label: 'Indicação' },
    { value: 'licitacoes', label: 'Portal de Licitações' },
  ];

  const usersList = [
    { value: '1', label: 'Administrador Master' },
    { value: '3', label: 'Usuário Teste' },
    { value: '4', label: 'Adrian Callmann' },
    { value: '5', label: 'Milena Alves' },
    { value: '6', label: 'Karina Moraes Piunti' },
    { value: '8', label: 'Rodrigo Lopes' },
  ];

  const contactsList = [
    { value: '1', label: 'José Pregoeiro' },
    { value: '2', label: 'Ana Gestora' },
  ];

  const publicOrgsList = [
    { value: '1', label: 'Prefeitura Municipal' },
    { value: '2', label: 'Secretaria de Educação' },
  ];




  // Funções de manipulação
  const handleFunnelChange = (selectedOption: any) => {
    setSelectedFunnel(selectedOption?.value || null);
  };

  const handleBidDateChange = (date: Date | null) => {
    setBidDate(date);
  };

  const convertOpportunityToFormData = (opportunity: Opportunity): OpportunityData => {
    console.log('Oportunidade antes da conversão para FormData:', opportunity);

    const result = {
      id: opportunity.id,
      numero_contrato: opportunity.numero_contrato, // Novo campo
      titulo: opportunity.title,
      id_origem: opportunity.source_id,
      nome_origem: opportunity.source,
      id_funil: opportunity.funnel_id,
      nome_funil: opportunity.funnel,
      id_etapa: opportunity.stage_id,
      nome_etapa: opportunity.stage,
      id_dono: opportunity.owner.id,
      nome_dono: opportunity.owner.name,
      id_contato: opportunity.contact_id,
      nome_contato: opportunity.contact,
      id_municipio: opportunity.municipio.id,
      nome_municipio: opportunity.municipio.nome,
      valor_licitacao: parseFloat(opportunity.value.replace(/[R$\s.]/g, '').replace(',', '.')),
      data_licitacao: opportunity.bidDate.toISOString(),
      status: opportunity.status as OpportunityStatus,
      id_conta: 2,
      probabilidade: 50,
      url_site_externo: opportunity.url_site_externo,
      uasb: opportunity.uasb === undefined ? '' : opportunity.uasb,
      tempo_entrega: opportunity.tempo_entrega === null || opportunity.tempo_entrega === undefined
        ? 'Sem informação' as TempoEntrega
        : opportunity.tempo_entrega as TempoEntrega
    };

    console.log('Resultado da conversão:', result);

    return result;
  };


  const forceCloseAllModals = () => {
    try {
      // Fechar qualquer modal ativo primeiro
      const activeModals = document.querySelectorAll('.modal.show');
      activeModals.forEach(modal => {
        try {
          const bootstrapModal = BootstrapModal.getInstance(modal as HTMLElement);
          if (bootstrapModal) {
            bootstrapModal.dispose();
          }
        } catch (e) {
          // Ignorar erros de Bootstrap
        }
      });

      // Remove todas as instâncias de modal Bootstrap
      const modalElements = document.querySelectorAll('.modal');
      modalElements.forEach(modalEl => {
        try {
          // Reset manual completo
          modalEl.classList.remove('show', 'fade', 'd-block');
          (modalEl as HTMLElement).style.display = 'none';
          modalEl.setAttribute('aria-hidden', 'true');
          modalEl.removeAttribute('aria-modal');
          modalEl.removeAttribute('role');
        } catch (e) {
          console.warn('Erro ao resetar modal:', e);
        }
      });

      // Remove todos os backdrops possíveis com seletores específicos
      const backdrops = document.querySelectorAll(
        '.modal-backdrop, .offcanvas-backdrop, .fade.show, [id*="backdrop"]'
      );
      backdrops.forEach(backdrop => {
        try {
          backdrop.remove();
        } catch (e) {
          console.warn('Erro ao remover backdrop:', e);
        }
      });

      // Reset completo do body
      document.body.classList.remove('modal-open', 'offcanvas-open');
      document.body.style.removeProperty('overflow');
      document.body.style.removeProperty('padding-right');
      document.body.style.removeProperty('margin-right');
      document.body.removeAttribute('data-bs-overflow');
      document.body.removeAttribute('data-bs-padding-right');

      // Verificação final múltipla
      [50, 100, 200].forEach(delay => {
        setTimeout(() => {
          const remainingBackdrops = document.querySelectorAll('.modal-backdrop, [id*="backdrop"]');
          remainingBackdrops.forEach(backdrop => backdrop.remove());
          document.body.classList.remove('modal-open');
          document.body.style.removeProperty('overflow');
        }, delay);
      });

    } catch (error) {
      console.error('Erro na limpeza forçada de modais:', error);
      // Limpeza final de emergência
      document.body.className = document.body.className.replace(/modal-open|offcanvas-open/g, '').trim();
      document.body.style.cssText = '';
      const allBackdrops = document.querySelectorAll('[class*="backdrop"]');
      allBackdrops.forEach(backdrop => backdrop.remove());
    }
  };

  const limparModal = (idModal: string) => {
    forceCloseAllModals();
  };

  const verificarAnexos = async (opportunityId: number): Promise<boolean> => {
    try {
      const response = await apiService.getAnexos({
        id_oportunidade: opportunityId,
        per_page: 1
      });

      // Garante que total existe e é um número maior que 0
      const total = response?.pagination?.total ?? 0;
      const temAnexos = Boolean(
        response?.success &&
        total > 0
      );

      console.log('Resposta da API de anexos:', response);
      console.log('Total na paginação:', total);
      console.log('Tem anexos:', temAnexos);

      return temAnexos;
    } catch (error) {
      console.error('Erro detalhado ao verificar anexos:', error);
      return false;
    }
  };

  const closeOffcanvas = () => {
    const offcanvasElement = document.getElementById('offcanvas_add');
    if (offcanvasElement) {
      import('bootstrap').then((bootstrap) => {
        const bsOffcanvas = new bootstrap.Offcanvas(offcanvasElement);
        bsOffcanvas.hide();
      });
    }
  };

  const handleCurrencyInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const numericValue = value.replace(/\D/g, '');
    const formattedValue = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(Number(numericValue) / 100);
    e.target.value = formattedValue;
  };

  // Atualiza o handleOpportunityCreated - Alternativa 1: Solução Robusta
  const handleOpportunityCreated = async (newOpportunity: Opportunity) => {
    console.log('Nova oportunidade criada:', newOpportunity);

    // Adicionar no hook original para compatibilidade
    addNewOpportunity(newOpportunity);

    // Aguardar um pouco mais para garantir que a API processou
    setTimeout(async () => {
      try {
        // Atualizar TODAS as etapas em vez de só a específica
        console.log('🔄 Iniciando refresh completo do kanban após criação...');
        await refreshAll();
        console.log('✅ Kanban atualizado completamente após criação');
      } catch (error) {
        console.error('❌ Erro ao atualizar kanban após criação:', error);
      }
    }, 200); // 500ms em vez de 100ms

    setCurrentOpportunityId(newOpportunity.id);
    setOpenModal(true);

    // Fecha o offcanvas
    closeOffcanvas();
  };

  const handleSubmit = (data: CreateOpportunityData) => {
    // Lógica para lidar com o submit
    console.log('Form data:', data);
    setOpenModal(true);
  };

  // Modificar a função handleAtualizarEtapa para indicar que está concluída
  const handleAtualizarEtapa = async () => {
    if (!detalhesMudancaEtapa.oportunidadeId || !detalhesMudancaEtapa.novaEtapaId) {
      console.error('Dados incompletos para atualização');
      return;
    }

    try {
      setAtualizandoEtapa(true);

      // Convertendo o ID para número na chamada da API
      const oportunidadeIdNumerico = parseInt(detalhesMudancaEtapa.oportunidadeId);

      if (isNaN(oportunidadeIdNumerico)) {
        throw new Error('ID de oportunidade inválido');
      }

      // 1. Atualizar a etapa da oportunidade
      await apiService.updateOpportunityStage(
        oportunidadeIdNumerico,
        detalhesMudancaEtapa.novaEtapaId
      );

      // 2. Atualizar campos personalizados da nova etapa
      await handleStageFieldsUpdate(
        oportunidadeIdNumerico,
        detalhesMudancaEtapa.novaEtapaId,
        apiService
      );

      // 3. Atualizar o estado local
      setOpportunities(prevOpportunities =>
        prevOpportunities.map(opp => {
          if (opp.id === detalhesMudancaEtapa.oportunidadeId) {
            const updatedOpp = {
              ...opp,
              stage_id: detalhesMudancaEtapa.novaEtapaId,
              stage: detalhesMudancaEtapa.novaEtapaNome
            };
            return updatedOpp;
          }
          return opp;
        })
      );

      // 4. Atualizar no sistema de lazy loading
      if (detalhesMudancaEtapa.etapaAntigaId && detalhesMudancaEtapa.novaEtapaId) {
        moveOpportunityBetweenEtapas(
          detalhesMudancaEtapa.oportunidadeId,
          detalhesMudancaEtapa.etapaAntigaId,
          detalhesMudancaEtapa.novaEtapaId
        );
      }

      // O modal fechará automaticamente através do manipulador de evento no modal
    } catch (error) {
      console.error('Erro ao atualizar etapa:', error);
      alert('Erro ao atualizar a etapa. Por favor, tente novamente.');

      // Garantir que sinalize o erro para o evento
      const event = new CustomEvent('etapaUpdated', {
        detail: { success: false, error }
      });
      document.dispatchEvent(event);
    } finally {
      setAtualizandoEtapa(false);
    }
  };

  const handleFilterApply = useCallback((newStatusFilters: string[]) => {
    console.log("🎯 DealsKanban recebeu os filtros:", newStatusFilters);
    console.log("📊 Quantidade de status filtrados:", newStatusFilters.length);

    // Definir contexto de loading como 'filtering'
    setLoadingContext('filtering');

    // Atualizar estado local dos filtros
    setStatusFilters(newStatusFilters);

    // Aplicar filtros no hook original para compatibilidade
    applyStatusFilters(newStatusFilters);

    // Refresh todas as etapas com novos filtros
    // O useEffect do hook lazy loading detectará a mudança nos filtros e reinicializará
  }, [applyStatusFilters]);

  // Função para lidar com pesquisa
  const handleSearch = useCallback((newSearchTerm: string) => {
    console.log("DealsKanban recebeu pesquisa:", newSearchTerm);

    // Definir contexto de loading como 'searching' apenas se há termo de busca
    setLoadingContext(newSearchTerm ? 'searching' : null);

    setSearchTerm(newSearchTerm);
    // O useEffect do hook lazy loading detectará a mudança na pesquisa e reinicializará
  }, []);

  // Função helper para obter mensagem de loading baseada no contexto
  const getLoadingMessage = useCallback((): string => {
    switch (loadingContext) {
      case 'filtering':
        return 'Aplicando filtros de status...';
      case 'searching':
        return 'Pesquisando oportunidades...';
      case 'changing-funnel':
        return 'Inicializando etapas do funil...';
      case 'initial':
        return 'Inicializando etapas do funil...';
      default:
        return 'Carregando...';
    }
  }, [loadingContext]);

  const renderCustomField = (field: CustomField) => {
    switch (field.type) {
      case 'file':
        return (
          <div className="custom-file">
            <input
              type="file"
              className="form-control"
              id={`field-${field.id}`}
              multiple
            />
          </div>
        );
      case 'text':
        return (
          <input
            type="text"
            className="form-control"
            id={`field-${field.id}`}
          />
        );
      default:
        return null;
    }
  };

  const [selectedDate, setSelectedDate] = useState<Date | null>(new Date());
  const handleDateChange = (date: Date | null) => {
    setSelectedDate(date);
  };
  const [selectedDate1, setSelectedDate1] = useState<Date | null>(new Date());
  const handleDateChange1 = (date: Date | null) => {
    setSelectedDate1(date);
  };
  const containerRefs = useRef<{ [key: number]: HTMLDivElement | null }>({});

  type EnsureDescricao<T extends { descricao?: string }> = Omit<T, 'descricao'> & { descricao: string };



  useEffect(() => {
    const topScroll = document.getElementById('topScroll');
    const mainScroll = document.getElementById('mainScroll');

    if (topScroll && mainScroll) {
      // Função para atualizar as dimensões
      const updateDimensions = () => {
        // Atualiza a largura do scroll superior para match exato
        const mainWidth = mainScroll.scrollWidth;
        const mainClientWidth = mainScroll.clientWidth;
        topScroll.style.width = `${mainClientWidth}px`;

        // Força mesmo comprimento de rolagem
        const phantomContent = topScroll.querySelector('.phantom-content') as HTMLElement;
        if (!phantomContent) {
          const div = document.createElement('div');
          div.className = 'phantom-content';
          topScroll.appendChild(div);
        }
        if (phantomContent) {
          phantomContent.style.width = `${mainWidth}px`;
        }
      };

      // Sincronização dos scrolls
      const syncScroll = (e: Event) => {
        const source = e.target as HTMLElement;
        const target = source.id === 'topScroll' ? mainScroll : topScroll;
        target.scrollLeft = source.scrollLeft;
      };

      // Inicializa e adiciona listeners
      updateDimensions();
      window.addEventListener('resize', updateDimensions);
      topScroll.addEventListener('scroll', syncScroll);
      mainScroll.addEventListener('scroll', syncScroll);

      // Cleanup
      return () => {
        window.removeEventListener('resize', updateDimensions);
        topScroll.removeEventListener('scroll', syncScroll);
        mainScroll.removeEventListener('scroll', syncScroll);
      };
    }
  }, [selectedFunnel?.etapas]);

  useEffect(() => {
    // Se o modal de contrato está visível, garante que o modal padrão não esteja
    if (showModalSucessoContrato) {
      setOpenModal(false);
    }
  }, [showModalSucessoContrato]);

  // Sincronizar filtros quando funil muda
  useEffect(() => {
    if (selectedFunnel && selectedFunnel.etapas.length > 0) {
      console.log('🔄 Funil selecionado mudou, reinicializando lazy loading:', selectedFunnel.id);
      // Definir contexto como 'changing-funnel'
      setLoadingContext('changing-funnel');
      // O hook lazy loading detectará automaticamente a mudança e reinicializará
    }
  }, [selectedFunnel]);

  // Resetar contexto de loading quando globalLoading terminar
  useEffect(() => {
    if (!globalLoading && loadingContext) {
      // Aguardar um pouco antes de limpar para garantir que a UI atualizou
      const timer = setTimeout(() => {
        setLoadingContext(null);
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [globalLoading, loadingContext]);

  // Debug: Monitorar mudanças nas oportunidades e nos dados das etapas
  useEffect(() => {
    console.log("📦 ESTADO ATUAL DO KANBAN:");
    console.log("- Total de oportunidades (hook original):", opportunities.length);
    console.log("- Status Filters ativos:", statusFilters);
    console.log("- Dados das etapas (lazy loading):", {
      totalEtapas: etapasData.size,
      detalhes: Array.from(etapasData.entries()).map(([etapaId, data]) => ({
        etapaId,
        totalOportunidades: data.opportunities.length,
        loading: data.loading,
        hasMore: data.hasMore,
        initialized: data.initialized
      }))
    });

  }, [opportunities, etapasData, statusFilters]);

  // Intercepta erros de modal Bootstrap para evitar console errors
  useEffect(() => {
    // Intercepta erros no window para capturar também erros assíncronos
    const handleError = (event: ErrorEvent) => {
      const errorMessage = event.message || '';
      if (
        errorMessage.includes("Cannot read properties of null (reading 'hide')") ||
        errorMessage.includes("modalInstance") ||
        errorMessage.includes("modal-backdrop") ||
        errorMessage.includes("Modal.getInstance")
      ) {
        event.preventDefault();
        event.stopPropagation();
        return false;
      }
    };

    const originalConsoleError = console.error;
    console.error = (...args) => {
      const errorMessage = args[0]?.toString?.() || '';
      if (
        errorMessage.includes("Cannot read properties of null (reading 'hide')") ||
        errorMessage.includes("modalInstance") ||
        errorMessage.includes("modal-backdrop") ||
        errorMessage.includes("Modal.getInstance")
      ) {
        return;
      }
      originalConsoleError.apply(console, args);
    };

    window.addEventListener('error', handleError);

    return () => {
      console.error = originalConsoleError;
      window.removeEventListener('error', handleError);
      forceCloseAllModals();
    };
  }, []);


  useEffect(() => {
    // Referência para o elemento que está sendo processado atualmente
    let processingElement: Element | null = null;

    // Função para lidar com o evento de conclusão da atualização
    const handleEtapaUpdated = (event: Event) => {
      const customEvent = event as CustomEvent;
      const { success } = customEvent.detail;

      // Encontrar cards com classe de processamento
      const processingCards = document.querySelectorAll('.processing-move');

      // Remover o efeito de todos os cards
      processingCards.forEach(card => {
        card.classList.remove('processing-move');

        // Opcional: adicionar brevemente uma classe de sucesso/erro
        if (success) {
          card.classList.add('move-success');
          setTimeout(() => {
            card.classList.remove('move-success');
          }, 1000);
        } else {
          card.classList.add('move-error');
          setTimeout(() => {
            card.classList.remove('move-error');
          }, 1000);
        }
      });
    };

    // Registrar o event listener
    document.addEventListener('etapaUpdated', handleEtapaUpdated);

    // Limpeza ao desmontar
    return () => {
      document.removeEventListener('etapaUpdated', handleEtapaUpdated);
    };
  }, []);

  // Modificação do useEffect do Dragula para comportamento semelhante ao Trello
  // Modificação do useEffect do Dragula para comportamento semelhante ao Trello
  // Com correção específica para o erro no evento 'drop' e compatibilidade com lazy loading
  useEffect(() => {
    if (!selectedFunnel?.etapas) return;

    // Aguardar um pouco para garantir que as colunas foram renderizadas
    const setupTimeout = setTimeout(() => {

    const validStages = selectedFunnel.etapas.filter(isStageWithId);
    const containers = validStages
      .map(etapa => {
        if (etapa.id && containerRefs.current && containerRefs.current[etapa.id]) {
          return containerRefs.current[etapa.id];
        }
        return null;
      })
      .filter((container): container is HTMLDivElement => container !== null);

    console.log('🔧 CONFIGURAÇÃO DRAGULA:');
    console.log('- Etapas válidas:', validStages.map(s => ({ id: s.id, nome: s.nome })));
    console.log('- Containers encontrados:', containers.length);
    console.log('- Containers:', containers.map(c => ({
      element: c,
      stageId: c.getAttribute('data-stage-id'),
      classes: c.className
    })));

    if (containers.length > 0) {
      // Configuração do Dragula com opções melhoradas para comportamento tipo Trello
      console.log('🎮 Inicializando dragula com', containers.length, 'containers');
      
      const drake = dragula(containers, {
        moves: function (el, container, handle) {
          console.log('🎯 MOVES check - elemento:', el?.getAttribute('data-opportunity-id'), 'container:', container?.getAttribute('data-stage-id'));
          if (!hasPermission('OPORTUNIDADES', 'MOVIMENTAR_KANBAN')) {
            return false;
          }
          return !document.body.classList.contains('modal-open');
        },
        accepts: function (el, target, source, sibling) {
          console.log('✅ ACCEPTS check - target:', target?.getAttribute('data-stage-id'), 'source:', source?.getAttribute('data-stage-id'));
          if (!hasPermission('OPORTUNIDADES', 'MOVIMENTAR_KANBAN')) {
            return false;
          }
          return !document.body.classList.contains('modal-open');
        },
        direction: 'vertical',
        revertOnSpill: true,
        mirrorContainer: document.body,
        ignoreInputTextSelection: true,
        copy: false,
        removeOnSpill: false,
        slideFactorX: 5,
        slideFactorY: 5
      });
      
      console.log('✅ Dragula inicializado com sucesso');
      
      // Solução alternativa: usar mouse events nativos para feedback visual durante drag
      let isDragging = false;
      let dragSourceContainer: HTMLElement | null = null;
      
      containers.forEach((container, index) => {
        const stageId = container.getAttribute('data-stage-id');
        
        container.addEventListener('mouseenter', (e) => {
          // Só aplicar feedback se estivermos arrastando e não for a coluna de origem
          if (isDragging && container !== dragSourceContainer) {
            console.log(`✅ Aplicando feedback visual na coluna ${stageId}`);
            safeAddClass(container, 'drag-container-over');
            
            // Aplicar estilo direto também para garantir que funcione
            (container as HTMLElement).style.backgroundColor = 'rgba(0, 123, 255, 0.15)';
            (container as HTMLElement).style.border = '4px solid #007bff';
            (container as HTMLElement).style.borderRadius = '10px';
            (container as HTMLElement).style.boxShadow = '0 0 25px rgba(0, 123, 255, 0.5)';
            (container as HTMLElement).style.transform = 'scale(1.02)';
            (container as HTMLElement).style.transition = 'all 0.2s ease';
            
            console.log(`🎨 Estilos diretos aplicados na coluna ${stageId}`);
          }
        });
        
        container.addEventListener('mouseleave', (e) => {
          // Remover feedback ao sair da coluna
          if (isDragging) {
            console.log(`🧹 Removendo feedback visual da coluna ${stageId}`);
            safeRemoveClass(container, 'drag-container-over');
            
            // Limpar estilos diretos também
            (container as HTMLElement).style.backgroundColor = '';
            (container as HTMLElement).style.border = '';
            (container as HTMLElement).style.borderRadius = '';
            (container as HTMLElement).style.boxShadow = '';
            (container as HTMLElement).style.transform = '';
            (container as HTMLElement).style.transition = '';
            
            console.log(`🎨 Estilos diretos removidos da coluna ${stageId}`);
          }
        });
      });

      // Funções de segurança para manipular classes de DOM
      const safeAddClass = (element: Element | null | undefined, className: string) => {
        try {
          if (element && element.classList) {
            element.classList.add(className);
          }
        } catch (e) {
          console.warn('Erro ao adicionar classe:', e);
        }
      };

      const safeRemoveClass = (element: Element | null | undefined, className: string) => {
        try {
          if (element && element.classList) {
            element.classList.remove(className);
          }
        } catch (e) {
          console.warn('Erro ao remover classe:', e);
        }
      };

      // Função para limpar classes de arrasto em todos os containers
      const cleanupDragClasses = () => {
        try {
          // Limpar classes dos containers
          containers.forEach(container => {
            if (container) {
              safeRemoveClass(container, 'drag-source');
              safeRemoveClass(container, 'drag-target');
              safeRemoveClass(container, 'drag-container-over');
            }
          });

          // Limpar qualquer elemento com classe is-dragging
          const draggingElements = document.querySelectorAll('.is-dragging');
          draggingElements.forEach(el => {
            safeRemoveClass(el, 'is-dragging');
          });
        } catch (e) {
          console.warn('Erro ao limpar classes de arrasto:', e);
        }
      };

      // Adicionar classe especial durante o arrasto para feedback visual
      drake.on('drag', function (el, source) {
        try {
          console.log('🚀 EVENTO DRAG iniciado!');
          
          // Atualizar variáveis de controle
          isDragging = true;
          dragSourceContainer = source as HTMLElement;
          
          console.log('- Elemento sendo arrastado:', el);
          console.log('- Container origem:', source);
          console.log('- Stage ID da origem:', source?.getAttribute('data-stage-id'));
          console.log('- Opportunity ID:', el?.getAttribute('data-opportunity-id'));
          
          if (el && el.classList) {
            safeAddClass(el, 'is-dragging');
            console.log('✅ Classe is-dragging adicionada ao elemento');
          }

          if (source && source.classList) {
            // Adicionar classe para indicar origem para estilização CSS
            safeAddClass(source, 'drag-source');
            console.log('✅ Classe drag-source adicionada à origem');
          }

          // Adicionar classe para todas as colunas de destino possíveis
          containers.forEach(container => {
            if (container && container !== source) {
              safeAddClass(container, 'drag-target');
            }
          });
          console.log('✅ Classe drag-target adicionada aos containers de destino');
          console.log('🎯 Sistema de feedback por mouse ativado');
        } catch (e) {
          console.warn('Erro no evento drag:', e);
        }
      });

      // Feedback visual simples - apenas contorno da coluna
      drake.on('over', function (el, container, source) {
        try {
          console.log('🎯 EVENTO OVER disparado!');
          console.log('- Elemento arrastado:', el);
          console.log('- Container destino:', container);
          console.log('- Container origem:', source);
          console.log('- Stage ID do destino:', container?.getAttribute('data-stage-id'));
          console.log('- Classes do container:', container?.className);
          console.log('- Container é diferente da origem?', container !== source);
          
          if (container && container !== source) {
            console.log('✅ Adicionando classe drag-container-over ao container');
            // Adicionar classe CSS para contornar a coluna
            safeAddClass(container, 'drag-container-over');
            console.log('- Classes após adicionar:', container.className);
          } else {
            console.log('❌ Container é igual à origem ou nulo');
          }
        } catch (e) {
          console.warn('Erro no evento over:', e);
        }
      });

      // Remover contorno quando sair da coluna
      drake.on('out', function (el, container) {
        try {
          console.log('🚪 EVENTO OUT disparado!');
          console.log('- Elemento arrastado:', el);
          console.log('- Container que saiu:', container);
          console.log('- Stage ID:', container?.getAttribute('data-stage-id'));
          
          if (container) {
            console.log('🧹 Removendo classe drag-container-over do container');
            // Remover classe CSS do container
            safeRemoveClass(container, 'drag-container-over');
            console.log('- Classes após remover:', container.className);
          }
        } catch (e) {
          console.warn('Erro no evento out:', e);
        }
      });

      // Função para limpar todos os efeitos visuais
      const cleanupAllVisualEffects = () => {
        console.log('🧹 Limpando todos os efeitos visuais');
        
        // Resetar variáveis de controle
        isDragging = false;
        dragSourceContainer = null;
        
        cleanupDragClasses();
        // Limpar classes CSS em todos os containers
        containers.forEach(container => {
          if (container) {
            // Remover classes CSS
            safeRemoveClass(container, 'drag-container-over');
            safeRemoveClass(container, 'drag-source');
            safeRemoveClass(container, 'drag-target');
          }
        });
        
        // Limpar qualquer elemento sendo arrastado
        const draggingElements = document.querySelectorAll('.is-dragging');
        draggingElements.forEach(el => {
          safeRemoveClass(el, 'is-dragging');
        });
        
        console.log('✅ Limpeza concluída - Sistema de feedback desativado');
      };

      // Evento 'cancel' - limpar tudo quando o arrasto é cancelado
      drake.on('cancel', function () {
        try {
          cleanupAllVisualEffects();
        } catch (e) {
          console.warn('Erro no evento cancel:', e);
        }
      });

      // Remover tudo ao finalizar o arrasto
      drake.on('dragend', function () {
        try {
          cleanupAllVisualEffects();
        } catch (e) {
          console.warn('Erro no evento dragend:', e);
        }
      });

      // Referência para armazenar o elemento que está sendo processado atualmente
      let currentProcessingElement: Element | null = null;

      // Função auxiliar para remover o efeito de processamento
      const removeProcessingEffect = (element: Element | null) => {
        try {
          if (element && element.classList) {
            safeRemoveClass(element, 'processing-move');
            safeRemoveClass(element, 'is-dragging');
          }
        } catch (e) {
          console.warn('Erro ao remover efeito de processamento:', e);
        }
      };

      // Listen para o modal sendo fechado para limpar o efeito do card
      const handleModalHide = () => {
        removeProcessingEffect(currentProcessingElement);
        currentProcessingElement = null;
      };

      // Registra evento para quando o modal for fechado
      const modalElement = document.querySelector('.modal-mudanca-etapa');
      if (modalElement) {
        modalElement.addEventListener('hidden.bs.modal', handleModalHide);
      }

      // Evento principal de drop - quando o cartão é solto
      drake.on('drop', function (el, target, source) {
        try {
          // Verificação de segurança - garantir que todos os elementos necessários existem
          if (!el || !target || !source) {
            console.warn('Drop cancelado: elementos inválidos');
            return;
          }

          const oportunidadeId = el.getAttribute('data-opportunity-id');
          const novaEtapaId = target.getAttribute('data-stage-id');
          const etapaAntigaId = source.getAttribute('data-stage-id');

          // Verificação de segurança - garantir que temos os IDs
          if (!oportunidadeId || !novaEtapaId) {
            console.warn('Drop cancelado: IDs inválidos');
            return;
          }

          // Se a etapa de destino for diferente da etapa de origem, processamos a mudança
          if (novaEtapaId !== etapaAntigaId) {
            // Cancelamos o drag visual, pois vamos tratar isso manualmente
            drake.cancel(true);

            // Salva referência ao elemento atual e adiciona classe para feedback visual
            currentProcessingElement = el;
            safeAddClass(el, 'processing-move');

            // Buscar oportunidade nas etapas lazy loading primeiro
            let oportunidade: Opportunity | undefined;
            
            Array.from(etapasData.values()).forEach((etapaData) => {
              const found = etapaData.opportunities.find((opp: Opportunity) => opp.id === oportunidadeId);
              if (found) {
                oportunidade = found;
              }
            });
            
            // Fallback para lista original se não encontrar no lazy loading
            if (!oportunidade) {
              oportunidade = opportunities.find(opp => opp.id === oportunidadeId);
            }

            const novaEtapa = selectedFunnel?.etapas
              .filter(isStageWithId)
              .find(stage => stage.id.toString() === novaEtapaId);

            if (oportunidade && novaEtapa) {
              setDetalhesMudancaEtapa({
                oportunidadeId,
                tituloOportunidade: oportunidade.title,
                novaEtapaId: novaEtapa.id,
                novaEtapaNome: novaEtapa.nome,
                etapaAntigaId: etapaAntigaId ? parseInt(etapaAntigaId) : null
              });

              // Exibe o modal imediatamente após os preparativos
              setShowModalMudancaEtapa(true);
            }
          }
        } catch (e) {
          // Tratamento de exceção para evitar que erros parem a execução
          console.error('Erro no evento drop:', e);
          // Cleanup em caso de erro
          cleanupDragClasses();
        }
      });

      return () => {
        // Limpar todas as classes CSS adicionadas
        cleanupDragClasses();

        // Destruir a instância do dragula
        try {
          drake.destroy();
        } catch (e) {
          console.warn('Erro ao destruir instância do dragula:', e);
        }

        // Limpar os listeners quando o componente for desmontado
        const modalElement = document.querySelector('.modal-mudanca-etapa');
        if (modalElement) {
          modalElement.removeEventListener('hidden.bs.modal', handleModalHide);
        }

        // Limpar qualquer efeito pendente
        if (currentProcessingElement) {
          removeProcessingEffect(currentProcessingElement);
        }
      };
    }

    }, 100); // Aguardar 100ms para garantir que as colunas foram renderizadas

    return () => {
      clearTimeout(setupTimeout);
    };
  }, [selectedFunnel?.etapas, opportunities, etapasData]);

  return (
    <>
      <>
        {/* Wrapper da Página */}
        <div className="page-wrapper">
          <div className="content">
            <div className="row">
              <div className="col-md-12">
                {/* Cabeçalho da Página */}
                <div className="page-header">
                  <div className="row align-items-center">
                    <div className="col-8">
                      {funnelsError ? (
                        <div className="alert alert-danger">
                          Erro ao carregar funis: {funnelsError}
                        </div>
                      ) : (
                        <FunnelSelector
                          funnels={funnels.map(funnel => ({
                            ...funnel,
                            descricao: funnel.descricao || '' // Garantir que descricao sempre existe
                          }))}
                          selectedFunnel={selectedFunnel ? {
                            ...selectedFunnel,
                            descricao: selectedFunnel.descricao || ''
                          } : null}
                          onFunnelChange={setSelectedFunnel}
                          loading={funnelsLoading}
                        />
                      )}
                    </div>
                    <div className="col-4 text-end">
                      <div className="head-icons">
                        <CollapseHeader />
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Cabeçalho da Página */}
                {/* Filtro */}
                <div className="d-flex justify-content-between align-items-center flex-wrap row-gap-2 mb-4">
                  <div className="d-flex align-items-center flex-wrap row-gap-2">
                    <FilterComponent
                      onApplyFilters={handleFilterApply}
                      initialFilters={{
                        'Aberta': true,
                        'Em Andamento': true,
                        'Ganha': false,
                        'Perdida': false
                      }}
                      isLoading={globalLoading || opportunitiesLoading} // Combinar ambos os loadings
                    />
                    
                    {/* Componente de Pesquisa */}
                    <div className="ms-3" style={{ minWidth: '300px' }}>
                      <SearchComponent
                        onSearch={handleSearch}
                        isLoading={globalLoading}
                        debounceDelay={600}
                      />
                    </div>
                  </div>
                  <div>
                    <ul className="d-flex align-items-center">
                      <ProtectedComponent module="OPORTUNIDADES" action="CRIAR">
                        <li>
                          <Link
                            to="#"
                            className="btn btn-primary"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvas_add"
                          >
                            <i className="ti ti-square-rounded-plus me-2" />
                            Adicionar Oportunidade
                          </Link>
                        </li>
                      </ProtectedComponent>
                    </ul>
                  </div>
                </div>
                {/* /Filter */}
                {/* Deals Kanban */}
                <div className="kanban-container">
                  {/* Scroll superior espelho */}
                  <div className="kanban-mirror-scroll" id="topScroll">
                    <div className="phantom-content"></div>
                  </div>
                  {/* Loading global */}
                  {globalLoading && (
                    <div className="text-center py-4 mb-4">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Carregando kanban...</span>
                      </div>
                      <p className="mt-2 text-muted">{getLoadingMessage()}</p>
                    </div>
                  )}

                  <div className="d-flex overflow-x-auto align-items-start mb-4" id="mainScroll">
                    {selectedFunnel?.etapas.map((etapa, index) => {
                      const etapaData = getEtapaData(etapa.id as number);
                      
                      return (
                        <KanbanColumn
                          key={etapa.id}
                          stage={etapa}
                          etapaData={etapaData}
                          onLoadMore={() => loadMoreEtapa(etapa.id as number)}
                          onRefresh={() => refreshEtapa(etapa.id as number)}
                          renderOpportunityCard={renderOpportunityCard}
                          containerRef={(el) => {
                            if (etapa.id !== undefined && typeof etapa.id === 'number') {
                              containerRefs.current[etapa.id] = el;
                            }
                          }}
                          stageIndex={index}
                        />
                      );
                    })}

                  </div>
                </div>
              </div>



            </div>
            {/* /Deals Kanban */}
          </div>
        </div >
        {/* /Page Wrapper */}
      </>

      <div
        className="offcanvas offcanvas-end offcanvas-extra-large"
        tabIndex={-1}
        id="offcanvas_add"
      >
        <div className="offcanvas-header border-bottom">
          <h5 className="fw-semibold">Nova Oportunidade</h5>
          <button
            type="button"
            className="btn-close custom-btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="offcanvas-body">
          <OpportunityForm
            funnels={funnels as Funnel[]}
            selectedFunnel={selectedFunnel as Funnel | null}
            setSelectedFunnel={setSelectedFunnel}
            usersList={usersList}
            setOpenModal={setOpenModal}
            modalType="create"
            onClose={() => {
              const offcanvasElement = document.getElementById('offcanvas_add');
              if (offcanvasElement) {
                const offcanvasInstance = Offcanvas.getInstance(offcanvasElement);
                offcanvasInstance?.hide();
              }
              setEditingOpportunity(null);
            }}
            onSubmit={handleSubmit}
            onOpportunityCreated={handleOpportunityCreated}
          />
        </div>
      </div>
      {/* /Add New Deals */}
      {/* Edit Deals */}
      <div
        className="offcanvas offcanvas-end offcanvas-extra-large"
        tabIndex={-1}
        id="offcanvas_edit"
      >
        <div className="offcanvas-header border-bottom">
          <h5 className="fw-semibold">Editar Oportunidade</h5>
          <button
            type="button"
            className="btn-close custom-btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            onClick={() => setEditingOpportunity(null)}
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="offcanvas-body">
          {editingOpportunity && (

            <OpportunityForm
              key={editingOpportunity.id}
              isEditing={true}
              initialData={convertOpportunityToFormData(editingOpportunity)}
              funnels={funnels}
              selectedFunnel={selectedFunnel}
              setSelectedFunnel={setSelectedFunnel}
              usersList={usersList}
              setOpenModal={setOpenModal}
              modalType="edit"
              onClose={() => {
                const offcanvasElement = document.getElementById('offcanvas_edit');
                if (offcanvasElement) {
                  const offcanvasInstance = Offcanvas.getInstance(offcanvasElement);
                  offcanvasInstance?.hide();
                }
                setEditingOpportunity(null);
              }}

              onSubmit={async (data) => {
                try {
                  // 1. Atualiza usando hook antigo
                  await handleUpdateOpportunity(editingOpportunity.id, data);

                  // 2. Atualizar kanban completo após edição - Alternativa 1
                  setTimeout(async () => {
                    try {
                      console.log('🔄 Iniciando refresh completo do kanban após edição...');
                      await refreshAll();
                      console.log('✅ Kanban atualizado completamente após edição');
                    } catch (error) {
                      console.error('❌ Erro ao atualizar kanban após edição:', error);
                    }
                  }, 200);

                  setOpenModal(true); // Abre o modal após sucesso
                } catch (error) {
                  console.error('Erro:', error);
                  alert('Erro ao atualizar oportunidade');
                }
              }}
              onOpportunityCreated={() => { }}
            />
          )}
        </div>
      </div>
      {/* /Edit Deals */}
      {/* Delete Deal */}
      <div className="modal fade" id="delete_deal" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="text-center">
                <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
                  <i className="ti ti-trash-x fs-36 text-danger" />
                </div>
                <h4 className="mb-2">Remove Deal?</h4>
                <p className="mb-0">
                  Are you sure you want to remove <br /> deal you selected.
                </p>
                <div className="d-flex align-items-center justify-content-center mt-4">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <Link to={route.deals} data-bs-dismiss="modal" className="btn btn-danger">
                    Yes, Delete it
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Delete Deal */}
      {/* Create Deal */}
      {/* Modal de Sucesso (Criação/Edição) */}
      <Modal show={openModal && !showModalSucessoContrato} onHide={() => setOpenModal(false)}>
        <div className="modal-header border-0 m-0 justify-content-end">
          <button
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={() => {
              setOpenModal(false);
              setCurrentOpportunityId(null);
            }}
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="modal-body">
          <div className="success-message text-center">
            <div className="success-popup-icon bg-light-blue">
              <i className="ti ti-medal" />
            </div>
            <h3>
              Oportunidade {document.getElementById('offcanvas_edit')?.classList.contains('show')
                ? 'Atualizada'
                : 'Criada'} com Sucesso
            </h3>
            <p>
              Ver Detalhes da Oportunidade {document.getElementById('offcanvas_edit')?.classList.contains('show')
                ? 'atualizada'
                : 'criada'}
            </p>
            <div className="col-lg-12 text-center modal-btn">
              <Link
                to="#"
                className="btn btn-light"
                onClick={() => {
                  setOpenModal(false);
                  setCurrentOpportunityId(null);
                }}
              >
                Cancelar
              </Link>
              {currentOpportunityId && (
                <Link
                  to={`/crm/oportunidades/detalhes/${currentOpportunityId}`}
                  className="btn btn-primary"
                >
                  Ver Detalhes
                </Link>
              )}
            </div>
          </div>
        </div>
      </Modal>
      {/* /Create Deal */}


      {/* Modal Excluir Oportunidade */}
      <div className="modal fade" id="delete_opportunity" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="text-center">
                <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
                  <i className="ti ti-trash-x fs-36 text-danger" />
                </div>
                <h4 className="mb-2">Remover Oportunidade?</h4>
                <p className="mb-0">
                  Tem certeza que deseja remover esta oportunidade?
                </p>
                <div className="d-flex align-items-center justify-content-center mt-4">
                  <button
                    type="button"
                    className="btn btn-light me-2"
                    onClick={() => {
                      forceCloseAllModals();
                    }}
                    disabled={isDeletingLocal || isDeleting}
                  >
                    Cancelar
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={handleDeleteOpportunity}
                    disabled={isDeletingLocal || isDeleting}
                  >
                    {(isDeletingLocal || isDeleting) ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Excluindo...
                      </>
                    ) : (
                      'Sim, Deletar'
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>



      <div className="modal fade custom-modal" id="success_delete_modal" tabIndex={-1} role="dialog" aria-hidden="true" style={{ zIndex: 1050 }}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="success-message text-center">
                <div className="avatar avatar-xl bg-success-light rounded-circle mb-3">
                  <i className="ti ti-check-check fs-36 text-success" />
                </div>
                <h3>Oportunidade Excluída com Sucesso!</h3>
                <p>A oportunidade foi removida permanentemente do sistema.</p>
                <div className="d-flex align-items-center justify-content-center mt-4">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => {
                      // Remover backdrop específico do modal de sucesso
                      const successBackdrop = document.getElementById('success-modal-backdrop');
                      if (successBackdrop) {
                        successBackdrop.remove();
                      }
                      
                      // Fechar o modal de sucesso
                      const successModal = document.getElementById('success_delete_modal');
                      if (successModal) {
                        successModal.classList.remove('show');
                        (successModal as HTMLElement).style.display = 'none';
                        successModal.setAttribute('aria-hidden', 'true');
                        successModal.removeAttribute('aria-modal');
                      }
                      
                      // Limpeza final
                      document.body.classList.remove('modal-open');
                      document.body.style.removeProperty('overflow');
                      document.body.style.removeProperty('padding-right');
                      
                      // Resetar o estado local do loading
                      setIsDeletingLocal(false);
                    }}
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Add New Pipeline */}
      <div
        className="offcanvas offcanvas-end offcanvas-large"
        tabIndex={-1}
        id="offcanvas_pipeline"
      >
        <div className="offcanvas-header border-bottom">
          <h4>Add New Pipeline</h4>
          <button
            type="button"
            className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="offcanvas-body">
          <form >
            <div>
              <div className="mb-3">
                <label className="col-form-label">
                  Pipeline Name <span className="text-danger">*</span>
                </label>
                <input className="form-control" type="text" />
              </div>
              <div className="mb-3">
                <div className="pipe-title d-flex align-items-center justify-content-between">
                  <h5 className="form-title">Pipeline Stages</h5>
                  <Link
                    to="#"
                    className="add-stage"
                    data-bs-toggle="modal"
                    data-bs-target="#add_stage"
                  >
                    <i className="ti ti-square-rounded-plus" />
                    Add New
                  </Link>
                </div>
                <div className="pipeline-listing">
                  <div className="pipeline-item">
                    <p>
                      <i className="ti ti-grip-vertical" /> Inpipeline
                    </p>
                    <div className="action-pipeline">
                      <Link
                        to="#"
                        data-bs-toggle="modal"
                        data-bs-target="#edit_stage"
                      >
                        <i className="ti ti-edit text-blue" />
                        Edit
                      </Link>
                      <Link
                        to="#"
                        data-bs-toggle="modal"
                        data-bs-target="#delete_stage"
                      >
                        <i className="ti ti-trash text-danger" />
                        Delete
                      </Link>
                    </div>
                  </div>
                  <div className="pipeline-item">
                    <p>
                      <i className="ti ti-grip-vertical" /> Follow Up
                    </p>
                    <div className="action-pipeline">
                      <Link
                        to="#"
                        data-bs-toggle="modal"
                        data-bs-target="#edit_stage"
                      >
                        <i className="ti ti-edit text-blue" />
                        Edit
                      </Link>
                      <Link
                        to="#"
                        data-bs-toggle="modal"
                        data-bs-target="#delete_stage"
                      >
                        <i className="ti ti-trash text-danger" />
                        Delete
                      </Link>
                    </div>
                  </div>
                  <div className="pipeline-item">
                    <p>
                      <i className="ti ti-grip-vertical" /> Schedule Service
                    </p>
                    <div className="action-pipeline">
                      <Link
                        to="#"
                        data-bs-toggle="modal"
                        data-bs-target="#edit_stage"
                      >
                        <i className="ti ti-edit text-blue" />
                        Edit
                      </Link>
                      <Link
                        to="#"
                        data-bs-toggle="modal"
                        data-bs-target="#delete_stage"
                      >
                        <i className="ti ti-trash text-danger" />
                        Delete
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mb-3">
                <h5 className="form-title">Access</h5>
                <div className="d-flex flex-wrap access-item nav">
                  <div
                    className="radio-btn"
                    data-bs-toggle="tab"
                    data-bs-target="#all"
                  >
                    <input
                      type="radio"
                      className="status-radio"
                      id="all"
                      name="status"
                      defaultChecked
                    />
                    <label htmlFor="all">All</label>
                  </div>
                  <div
                    className="radio-btn"
                    data-bs-toggle="tab"
                    data-bs-target="#select-person"
                  >
                    <input
                      type="radio"
                      className="status-radio"
                      id="select"
                      name="status"
                    />
                    <label htmlFor="select">Select Person</label>
                  </div>
                </div>
                <div className="tab-content mb-3">
                  <div className="tab-pane fade" id="select-person">
                    <div className="access-wrapper">
                      <div className="access-view">
                        <div className="access-img">
                          <ImageWithBasePath
                            src="assets/img/profiles/avatar-21.jpg"
                            alt="Image"
                          />
                          Vaughan
                        </div>
                        <Link to="#">Remove</Link>
                      </div>
                      <div className="access-view">
                        <div className="access-img">
                          <ImageWithBasePath
                            src="assets/img/profiles/avatar-01.jpg"
                            alt="Image"
                          />
                          Jessica
                        </div>
                        <Link to="#">Remove</Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-end">
              <button
                type="button"
                data-bs-dismiss="offcanvas"
                className="btn btn-light me-2"
              >
                Cancel
              </button>
              <button type="button" className="btn btn-primary">
                Create
              </button>
            </div>
          </form>
        </div>
      </div>
      {/* /Add New Pipeline */}

      {/* Delete Stage */}
      <div className="modal fade" id="delete_stage" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="text-center">
                <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
                  <i className="ti ti-trash-x fs-36 text-danger" />
                </div>
                <h4 className="mb-2">Remove Stage?</h4>
                <p className="mb-0">
                  Are you sure you want to remove <br /> stage you selected.
                </p>
                <div className="d-flex align-items-center justify-content-center mt-4">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <Link to={route.deals} data-bs-dismiss="modal" className="btn btn-danger">
                    Yes, Delete it
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Delete Stage */}
      {/* Add New Stage */}
      <div className="modal custom-modal fade" id="add_stage" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add New Stage</h5>
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <form >
                <div className="mb-3">
                  <label className="col-form-label">Stage Name *</label>
                  <input type="text" className="form-control" />
                </div>
                <div className="modal-btn text-end">
                  <Link to="#" className="btn btn-light" data-bs-dismiss="modal">
                    Cancel
                  </Link>
                  <button type="button" data-bs-dismiss="modal" className="btn btn-danger">
                    Save Changes
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Add New Stage */}
      {/* Edit Stage */}
      <div className="modal custom-modal fade" id="edit_stage" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit Stage</h5>
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <form >
                <div className="mb-3">
                  <label className="col-form-label">Stage Name *</label>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue="Inpipeline"
                  />
                </div>
                <div className="modal-btn text-end">
                  <Link to="#" className="btn btn-light" data-bs-dismiss="modal">
                    Cancel
                  </Link>
                  <button type="button" data-bs-dismiss="modal" className="btn btn-danger">
                    Save Changes
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Edit Stage */}
      {/* Add New View */}
      <div className="modal custom-modal fade" id="save_view" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add New View</h5>
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <form >
                <div className="mb-3">
                  <label className="col-form-label">View Name</label>
                  <input type="text" className="form-control" />
                </div>
                <div className="modal-btn text-end">
                  <Link to="#" className="btn btn-light" data-bs-dismiss="modal">
                    Cancel
                  </Link>
                  <button type="button" data-bs-dismiss="modal" className="btn btn-danger">
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Add New View */}
      <ModalMudancaEtapa
        show={showModalMudancaEtapa}
        onHide={() => setShowModalMudancaEtapa(false)}
        onConfirm={handleAtualizarEtapa}
        isUpdating={atualizandoEtapa}
        tituloOportunidade={detalhesMudancaEtapa.tituloOportunidade}
        novaEtapaNome={detalhesMudancaEtapa.novaEtapaNome}
      />

      <ModalSemAnexo
        show={showModalSemAnexo}
        onHide={() => setShowModalSemAnexo(false)}
        tituloOportunidade={oportunidadeSemAnexo}
      />

      <ModalSucessoContrato
        show={showModalSucessoContrato}
        onHide={() => {
          setShowModalSucessoContrato(false);
          setContratoGeradoId(undefined);
          setCurrentOpportunityId(null);

          // Garantir que o modal normal não seja exibido depois
          setOpenModal(false);
        }}
        idContrato={contratoGeradoId}
        idOportunidade={currentOpportunityId || undefined}
      />

    </>
  );
};